export default __webpack_public_path__ + "static/media/Group 746.d5fb2501.svg";